import React, { useState, useEffect } from "react";

import Input from "@mui/material/Input";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import EmailIcon from "@mui/icons-material/Email";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

import { useAuth } from "../../contexts/AuthContext.js";

export default function Second({ dispatchChangeStep }) {
  const [name, setName] = useState(Window.signInForm_1_name || "");
  const [phone, setPhone] = useState(Window.signInForm_1_phone || "+55 (");

  const [loading, setLoading] = useState();

  const [formRequirements, setFormRequirements] = useState(
    Window.signInForm_1_formRequirements || {
      nameValid: false,
      phoneValid: false,
    }
  );

  const { handleCreateAccount } = useAuth();

  useEffect(handleNameValidation, [name]);
  useEffect(handlePhoneValidation, [phone]);

  function handleNameValidation() {
    const newFormRequirements = { ...formRequirements };
    const nameParts = name.trim().split(" ");
    newFormRequirements.nameValid =
      nameParts.length >= 2 && nameParts.every((part) => part.length > 1);
    Window.signInForm_1_formRequirements = newFormRequirements;
    setFormRequirements({ ...newFormRequirements });
  }
  function handlePhoneValidation() {
    const newFormRequirements = { ...formRequirements };
    newFormRequirements.phoneValid = /^\+55 \(\d{2}\) \d \d{4}-\d{4}$/.test(
      phone
    );
    Window.signInForm_1_formRequirements = newFormRequirements;
    setFormRequirements({ ...newFormRequirements });
  }

  function handleNextStep(e) {
    e?.preventDefault();
    dispatchChangeStep({ current: 2, goTo: 3 });
  }
  function isFormValid() {
    return formRequirements.nameValid, formRequirements.phoneValid;
  }
  function handleInputFocus(e) {
    document.getElementById(e.target.id).scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "center",
    });
  }

  async function handleSubmit(e) {
    e.preventDefault();

    setLoading(true);

    try {
      window.trackSignIn({
        email: SubmitParse.email(Window.signInForm_1_email),
        name: SubmitParse.name(Window.signInForm_1_name),
        phone: SubmitParse.phone(Window.signInForm_1_phone),
      });

      const result = await handleCreateAccount({
        name: SubmitParse.name(Window.signInForm_1_name),
        phone: SubmitParse.phone(Window.signInForm_1_phone),
        email: SubmitParse.email(Window.signInForm_1_email),
        password: Window.signInForm_1_password,
      });

      if (!result) {
        alert(
          "Houve um erro ao criar sua conta, verifique os dados inseridos e tente novamente"
        );
        setLoading(false);
      }
    } catch (e) {
      console.log(e);
    }

    setLoading(false);
  }

  const SubmitParse = {
    name(v) {
      return v
        .trim()
        .split(" ")
        .map((word) => {
          if (word.length <= 2) {
            return word.toLowerCase();
          }
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(" ");
    },
    email(v) {
      return v.trim().toLowerCase();
    },
    phone(v) {
      return `+${v.replace(/[^\d]/g, "")}`;
    },
  };

  return (
    <form onSubmit={handleNextStep} className="signin-form mt-2">
      <Field
        onFocus={handleInputFocus}
        label="Seu nome"
        placeholder="insira seu nome completo"
        endAdornment
        onInput={(v) => {
          Window.signInForm_1_name = v.target.value;
          setName(v.target.value);
        }}
        value={name}
        autoFocus={true}
      />
      <Field
        onFocus={handleInputFocus}
        label="Seu celular"
        placeholder="(ddd) 9 **** ****"
        endAdornment
        onInput={(v) => {
          const { value } = v.target;
          const formattedValue = formatPhoneNumber(value);
          setPhone(formattedValue);

          Window.signInForm_1_phone = v.target.value;
        }}
        value={phone}
      />
      <Button
        variant="contained"
        disabled={!isFormValid() || loading}
        color="primary"
        className="signin-btn py-2 mt-3"
        startIcon={<ArrowForwardIosIcon />}
        onClick={handleSubmit}
        key={Math.random()}
        type="button"
      >
        Próxima etapa: Criar desafio
      </Button>
      <Button
        variant="outlined"
        onClick={() => dispatchChangeStep({ current: 2, goTo: 1 })}
        color="primary"
        className="signin-btn py-2"
        type="button"
      >
        Voltar
      </Button>
    </form>
  );
}

const formatPhoneNumber = (value) => {
  // Remove todos os caracteres não numéricos, exceto o prefixo +55
  const phoneNumber = value.replace(/[^\d]/g, "").slice(2);

  // Adiciona o código de país +55 e formata conforme a máscara desejada
  const match = phoneNumber.match(/^(\d{2})(\d{1})(\d{4})(\d{4})$/);

  if (match) {
    return `+55 (${match[1]}) ${match[2]} ${match[3]}-${match[4]}`;
  } else if (phoneNumber.length <= 2) {
    return `+55 (${phoneNumber}`;
  } else if (phoneNumber.length <= 3) {
    return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(2)}`;
  } else if (phoneNumber.length <= 7) {
    return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(
      2,
      3
    )} ${phoneNumber.slice(3)}`;
  } else {
    return `+55 (${phoneNumber.slice(0, 2)}) ${phoneNumber.slice(
      2,
      3
    )} ${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7, 11)}`;
  }
};

const Field = ({
  onFocus,
  label,
  placeholder,
  endAdornment,
  onInput,
  value,
  type = "text",
  autoFocus = false,
}) => {
  return (
    <TextField
      onFocus={onFocus}
      label={label}
      placeholder={placeholder}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">{endAdornment}</InputAdornment>
        ),
        autoFocus: autoFocus,
      }}
      onInput={onInput}
      variant="outlined"
      color="primary"
      value={value}
      type={type}
      className="slide-right-fade mt-1 mb-2"
      style={{ animationDelay: "0.1s" }}
    />
  );
};

const PasswordIndicators = ({ states }) => {
  const requirements = {
    charactersNumber: "No mínimo 8 caracteres",
    atLeastACapitalLetter: "Pelo menos uma letra minúscula",
    lettersAndNumbers: "Letras e números",
    confirmPassword: "As duas senhas inseridas devem ser iguais",
  };

  console.log("States", states);

  return (
    <div
      className="confirm-password-indicators"
      style={{ animationDelay: "0.2s" }}
    >
      {Object.keys(requirements).map((requirement, i) => (
        <Typography variant="h5" component="h5">
          <span
            className="indicator-circle"
            style={{
              backgroundColor:
                !!states && !!states[requirement] ? "green" : "#c4c4c4",
            }}
          />
          {requirements[requirement]}
        </Typography>
      ))}
    </div>
  );
};
